<template>
  <div
    v-b-tooltip.hover
    class="header-btn"
    :title="dwStatusTooltip"
    @click="$emit('click')"
  >
    <i class="fa fa-database" />
    <div class="text-container">
      <span class="btn-text">Estado de Carga</span>
      <span
        v-if="dwStatusDateText"
        class="date-text"
      >{{ dwStatusDateText }}</span>
    </div>
    <span
      v-if="dwJobLoading"
      class="progress-mini"
    >
      {{ dwJobProgress || 0 }}%
    </span>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from '@vue/composition-api'
import { general } from '@/services/api/ExpertoRetail'
import webSocketMessageHandler from '@/services/WebSocketMessageHandler'

export default {
  name: 'DwStatusButton',
  setup (props, { emit, root }) {
    const lastDwUpdate = ref(null)
    const dwJobLoading = ref(false)
    const dwJobProgress = ref(0)
    let dwStatusInterval = null

    const $moment = root.$moment

    const dwStatusTooltip = computed(() => {
      if (dwJobLoading.value) {
        return 'Estado de carga de datos - Actualizando...'
      }
      if (lastDwUpdate.value) {
        return `Estado de carga de datos\n\nÚltima actualización:\n${lastDwUpdate.value}`
      }
      return 'Estado de carga de datos'
    })

    const dwStatusDateText = computed(() => {
      if (lastDwUpdate.value && !dwJobLoading.value) {
        const lastUpdate = $moment(lastDwUpdate.value, 'ddd D MMM YYYY H:mm')
        return lastUpdate.format('DD/MM HH:mm')
      }
      return null
    })

    async function fetchInitialDwStatus () {
      try {
        const dwStatusArr = await general.dwJobResultStatus()
        if (Array.isArray(dwStatusArr) && dwStatusArr.length > 0) {
          const latest = dwStatusArr.reduce((a, b) => (a.finished_at > b.finished_at ? a : b))
          if (latest.finished_at) {
            lastDwUpdate.value = $moment(Number(latest.finished_at)).local().format('ddd D MMM YYYY H:mm')
          }
        }
      } catch (error) {
        // Silently fail, no error dot
      }
    }

    function handleEtlJobUpdate (eventData) {
      const { progress, isWorking, isDone, hasError, finished_at: finishedAt } = eventData
      dwJobLoading.value = isWorking
      if (progress !== null) {
        dwJobProgress.value = progress
      }
      if (isDone || hasError) {
        if (finishedAt) {
          lastDwUpdate.value = $moment(Number(finishedAt)).local().format('ddd D MMM YYYY H:mm')
        } else {
          lastDwUpdate.value = $moment().local().format('ddd D MMM YYYY H:mm')
        }
      }
    }

    function startDwStatusCheck () {
      dwStatusInterval = setInterval(fetchInitialDwStatus, 300000) // 5 minutes
    }
    function stopDwStatusCheck () {
      if (dwStatusInterval) {
        clearInterval(dwStatusInterval)
        dwStatusInterval = null
      }
    }

    onMounted(() => {
      webSocketMessageHandler.on('dwEtlJobUpdate', handleEtlJobUpdate)
      fetchInitialDwStatus()
      startDwStatusCheck()
    })
    onBeforeUnmount(() => {
      webSocketMessageHandler.off('dwEtlJobUpdate', handleEtlJobUpdate)
      stopDwStatusCheck()
    })

    return {
      dwStatusTooltip,
      dwStatusDateText,
      dwJobLoading,
      dwJobProgress
    }
  }
}
</script>

<style scoped>
.text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
  margin: 0;
  padding: 0;
}

.btn-text {
  margin: 0;
  padding: 0;
  font-size: 0.875rem;
}

.date-text {
  font-size: 0.65em;
  opacity: 0.8;
  margin: 0;
  padding: 0;
}

/* No custom styles: uses header-btn, btn-text, btn-date, progress-mini from global/header styles */
</style>



// WEBPACK FOOTER //
// src/app/nav_bar/components/DwStatusButton.vue